import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { hotelFormDefault } from "@factory/form/form.default";
import { HotelFormRule, HotelFormSchema } from "@factory/form/form.rule";
import { useQyCreateHotel } from "@factory/query/hotel.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewHotel() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateHotel } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Hotel is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addHotel, isLoading: isCreating } =
    useQyCreateHotel(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<HotelFormSchema>({
    defaultValues: hotelFormDefault,
    resolver: zodResolver(HotelFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: HotelFormSchema) => {
    const formData = mapCreateHotel(form);
    addHotel(formData);
  };
  const handleValidateError = (err: FieldErrors<HotelFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
